var map = {
	"./dashboard/routes.ts": 96773,
	"./parametros-diario/acesso-servidor/routes.ts": 7162,
	"./parametros-diario/ausencia-do-servidor/routes.ts": 64233,
	"./parametros-diario/autorizacao-outro-servidor/routes.ts": 73224,
	"./parametros-diario/calendario-componente/routes.ts": 45624,
	"./parametros-diario/excecao_horario/routes.ts": 65492,
	"./parametros-diario/habilitar-uso-diario-digital-ensino/routes.ts": 43070,
	"./parametros-diario/habilitar-uso-diario-digital/routes.ts": 12317,
	"./parametros-diario/horario-recuperacao/routes.ts": 16328,
	"./parametros-diario/horario-turma/routes.ts": 56367,
	"./parametros-diario/inclusao-de-opcao-para-o-componente-da-turma/routes.ts": 28708,
	"./parametros-diario/instrumentos-pedagogicos/routes.ts": 28882,
	"./parametros-diario/objetos-conhecimento/routes.ts": 95148,
	"./parametros-diario/unidade-didatica/routes.ts": 72205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93019;